export default {"src":"/_next/static/media/andriod.5389f573.svg","height":26,"width":23,"blurWidth":0,"blurHeight":0};